import React from 'react';

const JSONToHTMLTable = props => {
  let { data, wrapperClassName, tableClassName } = props;
  if (!wrapperClassName) wrapperClassName = 'MuiPaper-root MuiTableContainer-root MuiPaper-elevation1 MuiPaper-rounded';
  if (!tableClassName) tableClassName = 'MuiTable-root';
  return (
    <div className={wrapperClassName}>
      <table className={tableClassName}>
        <tbody>
          {Object.keys(data).map(k => (
            <tr key={k}>
              {!Array.isArray(data) && <td>{k.replace(/_/g, ' ')}</td>}
              {(() => {
                if (data[k] && typeof data[k] === 'object') {
                  return (
                    <td>
                      <JSONToHTMLTable data={data[k]} tableClassName={tableClassName} />
                    </td>
                  );
                }
                return (
                  <td>
                    <span dangerouslySetInnerHTML={{ __html: data[k] }} />
                  </td>
                );
              })()}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default JSONToHTMLTable;
